import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog) = $event)),
    title: _ctx.$t('billing.requestInvoice'),
    width: "50%",
    fullscreen: _ctx.type === 'sm' ? true : false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "billingFormRef",
        model: _ctx.billingForm,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "socialR" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.billingForm.socialR,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billingForm.socialR) = $event)),
                placeholder: _ctx.$t('billing.form.socialR'),
                onInput: _cache[1] || (_cache[1] = 
            () => (_ctx.billingForm.socialR = _ctx.billingForm.socialR.toUpperCase())
          )
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "RFC" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.billingForm.RFC,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.billingForm.RFC) = $event)),
                placeholder: "RFC"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "cp" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.billingForm.cp,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.billingForm.cp) = $event)),
                placeholder: 'CP'
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "fiscalR" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "w-full",
                modelValue: _ctx.billingForm.fiscalR,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.billingForm.fiscalR) = $event)),
                placeholder: _ctx.$t('billing.form.fiscalR')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regimenFiscal, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.title,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "CFDI" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "w-full",
                modelValue: _ctx.billingForm.CFDI,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.billingForm.CFDI) = $event)),
                placeholder: _ctx.$t('billing.form.CFDI')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cfdiUse, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.title,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestBilling(_ctx.billingFormRef)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("billing.form.send")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "fullscreen"]))
}